import { render, staticRenderFns } from "./HtmlEmbed.vue?vue&type=template&id=24197127&scoped=true&"
import script from "./HtmlEmbed.vue?vue&type=script&lang=js&"
export * from "./HtmlEmbed.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEmbed.vue?vue&type=style&index=0&id=24197127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24197127",
  null
  
)

export default component.exports